import { render, staticRenderFns } from "./SellReportPage.vue?vue&type=template&id=612cfb7e&scoped=true"
import script from "./SellReportPage.vue?vue&type=script&lang=js"
export * from "./SellReportPage.vue?vue&type=script&lang=js"
import style0 from "./SellReportPage.vue?vue&type=style&index=0&id=612cfb7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612cfb7e",
  null
  
)

export default component.exports